import { Injectable, inject } from "@angular/core";
import { GridRendererProvider } from "../data-grid/grid-renderer-provider.interface";
import { TransformerService } from "./transformer.service";
import { DefaultGridRendererProvider } from "../data-grid/default-grid-renderer-provider";
import { HeaderRendererItem } from "../data-grid/header-renderer-item";

@Injectable({ providedIn: "root" })
export class TransformerGridRendererService implements GridRendererProvider {
  protected xformService = inject(TransformerService);

  private defaultProvider: GridRendererProvider = new DefaultGridRendererProvider();
  private provider: GridRendererProvider | null = null;

  constructor() {
    this.defaultProvider = new DefaultGridRendererProvider();
    this.xformService.activeTransformer$.subscribe((xformer) => {
      this.provider = xformer ? (xformer.gridRendererProvider ?? null) : null;
    });
  }

  public getRowNumberHeaderRenderer(): HeaderRendererItem | null {
    const renderer = this.provider ? this.provider.getRowNumberHeaderRenderer() : null;
    return renderer || this.defaultProvider.getRowNumberHeaderRenderer();
  }

  getCellRenderer(colId: string) {
    const renderer = this.provider ? this.provider.getCellRenderer(colId) : null;
    return renderer || this.defaultProvider.getCellRenderer(colId);
  }

  getHeaderRenderer(colId: string) {
    const renderer = this.provider ? this.provider.getHeaderRenderer(colId) : null;
    return renderer || this.defaultProvider.getHeaderRenderer(colId);
  }

  getHeaderHeight(): number {
    return this.provider ? this.provider.getHeaderHeight() : this.defaultProvider.getHeaderHeight();
  }
}
